module.exports = __webpack_public_path__ + "static/media/facebook.a4ab7a63.svg";